// src/shared/api/fetcher.ts
import { axiosInstance } from './client';

export default function fetcher<T = unknown>(url: string): Promise<T> {
  return axiosInstance.get<T>(url).then((res) => res.data);
}
